<template>
  <section id="como-trabajamos" class="py-3 bg-white">
    <div class="container">
      <h2 class="h2 fw-bold text-center mb-4">Cómo trabajamos</h2>
      <div class="row g-4 justify-content-center">
        <div class="col-md-10 col-lg-8">
          <p class="mb-3 text-center">
            <i class="fa-solid fa-satellite-dish text-primary" style="font-size: 2.5rem;" aria-hidden="true"></i>
            <i class="fa-solid fa-video text-primary ms-3" style="font-size: 2.5rem;" aria-hidden="true"></i>
          </p>
          <p class="text-muted mb-3">
            Trabajamos con <strong class="text-dark">equipos profesionales</strong>, ofreciendo calidad <strong class="text-dark">HD a 60 fps</strong> tanto en transmisiones como en filmaciones. Realizamos <strong class="text-dark">transmisiones en vivo en zonas rurales</strong> usando equipo satelital <strong class="text-dark">Starlink</strong>, para que tu evento llegue a quien quieras. Nos <strong class="text-dark">adaptamos al paquete que el cliente necesite</strong>: podemos hacer <strong>solo transmisión en vivo</strong>, <strong>solo grabación</strong>, o <strong>ambos</strong>.
          </p>
          <div class="text-muted mb-0 small text-start mb-3">
            <strong class="text-dark d-block">Entregas:</strong>
            <ul class="mb-0 small ps-3" style="list-style-type: disc;">
              <li>Enlace de YouTube (video privado o público)</li>
              <li>Memoria USB</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
</script>

<style scoped>
</style>
